import { cloneDeep, noop } from 'lodash';
import { planTypes, BILLING_CYCLE } from '@/common/constants';
import plans from "@/plans";
import { plansof } from '@/utils/chain';
import { isSelectedPlanMixedFreeTrial } from '@/common/service/free-trial';
import { isOnlineNotSupportPlan } from '@/common/service/non-standard-billing-cycle-utils';
import qs from 'qs';

export function getSelectedPlanListPayLoad (getSelectedPlans, filterVendorProduct = true) {
  let list = cloneDeep(getSelectedPlans.filter(p => filterVendorProduct ? !p.isVendorProduct : true));

  list = list.filter(p => {
    // remove pro single use plan
    if (p.type === planTypes.ZOOM_MEETING && p.billing_cycle === BILLING_CYCLE.ONE_TIME) return false;
    return true;
  });

  // post process before data is sent
  plans.forEach(PLAN => {
    const planType = planTypes[PLAN.key];
    const post = PLAN.post || noop;
    post(plansof(list).type(planType).get());
  });

  return list?.map((plan) => {
    const res = {
      quantity: plan.cartInfo.selected_number,
      planCode: plan.plan_code
    };
    // FREE TRIAL - free trial data need more info like trialDays
    if (plan.isOnlineFreeTrial && plan.trialDays) {
      res.trialCode = plan.trialCode || '';
      // Only if buy normal plan and free trial plan together, we should add planExtension field here.
      // Otherwise submit api will return error
      if (isSelectedPlanMixedFreeTrial()) {
        res.planExtension = {
          campaignCode: plan.campaignCode,
          trialCode: plan.trialCode,
          freeTrialSource: qs.parse(location.search.slice(1))['itm_source'] || 'Direct Link'
        }
      }
    }
    //special billing cycle plan should distinguish by plan_type
    if (isOnlineNotSupportPlan({
      planType: plan.type,
      billingCycle: plan.billing_cycle,
      category: plan.category
    })) {
      res.planType = plan.plan_type;
    }
    return res;
  })
}
